module.exports = __webpack_public_path__ + "images/jdf-logo-green-xl@1x8fa45bd9ae99db0de2803ed336f31df8.png";